import classnames from 'classnames';

import { CohortsIcon2 } from '@medeloop/medeloop-components-library';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Study } from 'src/types/studies';

export const StudyCard = ({ study }: { study: Study }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`studies/${study.studyId}`);
  };

  return (
    <div
      key={study.studyId}
      className={classnames(
        'flex flex-col items-start w-[412px]  px-4 py-6 rounded gap-4 cursor-pointer',
        'bg-gray-900  border-sm border border-gray-800 hover:bg-gray-800 line-clamp-1',
      )}
      onClick={handleClick}
    >
      <div className="flex items-start flex-col gap-1">
        <span className="text-gray-500 text-sm">{study.organizationName}</span>
        <span className="text-white font-bold line-clamp-1">{study.name}</span>
        <div className="flex items-center gap-2 text-white text-sm">
          <CohortsIcon2 className="h-4 w-4 text-yellow-300" />
          {study.numParticipants} {t('num_participants')}
        </div>
      </div>
    </div>
  );
};
